/** @format */

export const getModelOverviewGridTemplateColumns = ({
    hasImages,
    isLoadingImages,
    isSmallTablet,
}: {
    hasImages: boolean;
    isLoadingImages: boolean;
    isSmallTablet: boolean;
}) => {
    // eslint-disable-next-line @typescript-eslint/naming-convention -- Legacy code: do not use as an example.
    const showImageLayout = hasImages || isLoadingImages;

    if (!showImageLayout || isSmallTablet) {
        return '1fr';
    }

    return '1fr 1fr';
};
